import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { Button, Label } from '@shared/ui';

import { clubCheckLanguage } from '../../model';
export const ClubCheck = () => {
  return (
    <div className='bg-background h-full flex flex-col items-center justify-between w-screen pb-5'>
      <div className=''></div>
      <div className='flex flex-col items-center justify-center gap-4 pt-6'>
        <Image src='/resources/bashgahLogo.svg' alt='bashgah' width={140} height={100} />
        <Label className='h5-bold px-5 text-center'>{clubCheckLanguage.clubCheck}</Label>
      </div>
      <Link
        target='_blank'
        href={'https://bashgah.com/Intro/?utm_source=myagah&utm_medium=cta&utm_content=profile'}
        className='w-full h-auto items-start flex justify-center mt-4'
      >
        <Button className='h-[60px] w-full gap-x-1 mx-5' type='submit'>
          {clubCheckLanguage.clubCheckButton}
        </Button>
      </Link>
    </div>
  );
};
